'use strict'

define [], () ->
  ($rootScope, $scope, $http, RentappService, RENTAPPLICATION_API_URL, $uibModalInstance) ->
    $scope.is_loading = false
    $scope.ssn = ""
    $scope.dob = ""
    $scope.error_message = ""
   
    $scope.update_info = () ->
      if not $scope.ssn or not $scope.dob
        return
      $scope.is_loading = true
      $http.put "#{RENTAPPLICATION_API_URL}/api/v3/referrers/stripe_info/",
        id_number: $scope.ssn
        dob: $scope.dob
      .then (resp) ->
        $uibModalInstance.close(resp.data)
      .catch (err) ->
        console.log(err)
      .finally ->
        $scope.is_loading = false
      


// WEBPACK FOOTER //
// ./components/dashboard/referral/modals/additional_info.coffee